// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 5724) return "static/chunks/5724-30be98f857e06c33.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2261":"458e9658c8a3277e","3752":"b95dd46052686d5b"}[chunkId] + ".js";
};